import { render } from "./AppConfig.vue?vue&type=template&id=2983a8c6"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__